import { alpha, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    width: "512px",
    height: "781px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "6px",
    border: `1px solid ${theme.palette.divider}`,
    opacity: 1,
    overflow: "hidden",
    flexShrink: 0,
  },
  header: {
    width: "100%",
    maxWidth: "100%",
    height: "67px",
    boxSizing: "border-box",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    padding: "10px 16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "8px",
    borderBottom: `2px solid ${theme.palette.divider}`,
    opacity: 1,
    flexShrink: 0,
    textAlign: "right",
  },
  title: {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "21px",
    margin: 0,
    width: "100%",
    textAlign: "right",
    fontFamily: "Noto Sans Hebrew",
  },
  subtitle: {
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "18px",
    color: alpha(theme.palette.common.white, 0.75),
    opacity: 1,
    margin: 0,
    width: "100%",
    textAlign: "right",
    whiteSpace: "nowrap",
    fontFamily: "Noto Sans Hebrew",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "16px",
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  bodyNotesTab: {
    overflow: "hidden",
  },
  badges: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    width: "100%",
    maxWidth: "100%",
    minHeight: "33px",
    alignItems: "center",
    justifyContent: "flex-end",
    '$card[dir="rtl"] &': {
      flexDirection: "row-reverse",
      justifyContent: "flex-end",
    },
  },
  badgeDefault: {
    fontSize: "14px",
    lineHeight: "21px",
    letterSpacing: "0.04em",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.grey[400],
    borderRadius: "16px",
    padding: "4px 12px",
    whiteSpace: "nowrap",
    fontFamily: "Noto Sans Hebrew",
  },
  badgeLabel: {
    fontWeight: 600,
    color: theme.palette.secondary.main,
    fontFamily: "Noto Sans Hebrew",
  },
  badgeValue: {
    fontWeight: 400,
    fontFamily: "Noto Sans Hebrew",
  },
  badgeDanger: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    letterSpacing: "0.04em",
    color: theme.palette.error.main,
    backgroundColor: alpha(theme.palette.error.main, 0.1),
    borderRadius: "16px",
    padding: "4px 12px",
    whiteSpace: "nowrap",
    fontFamily: "Noto Sans Hebrew",
  },
  tabs: {
    width: "366px",
    height: "42px",
    minHeight: "42px",
    maxWidth: "100%",
    marginLeft: "auto",
    opacity: 1,
    flexShrink: 0,
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& .MuiTabs-scroller": {
      overflow: "hidden !important",
    },
    "& .MuiTabs-flexContainer": {
      height: "42px",
    },
    '$card[dir="rtl"] &': {
      "& .MuiTabs-flexContainer": {
        flexDirection: "row-reverse",
      },
    },
    "& .MuiTab-root": {
      minHeight: "42px",
      height: "42px",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
      letterSpacing: "0.04em",
      textTransform: "none",
      color: theme.palette.text.primary,
      padding: 0,
      minWidth: 0,
      flex: 1,
      fontFamily: "Noto Sans Hebrew",
    },
    "& .Mui-selected": {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: 600,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    minWidth: 0,
  },
  contentNotesTab: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
}));
